export default __webpack_public_path__ + "img/map-marker-adult_resources-active.6ae2bf3a.png";